import axios from 'axios.js'

export const GET_ACTIVE_DEVICES = 'GET_ACTIVE_DEVICES'

export const getLabolink = () => (dispatch) => {
    let search_url = "/api/common/labolink"
    axios.get(search_url).then((res) => {
        if(res.data.result_status === 200){
            dispatch({
                type: GET_ACTIVE_DEVICES,
                payload: res.data.data,
            })
        }else{
            dispatch({
                type: GET_ACTIVE_DEVICES,
                payload: [],
            })
        }
    })
}




